import { revokeToken } from '../api/console-client'
import { clearAuth, loadAuth } from '../project/auth'
import type { OperationOptions } from './types'
import { emitter } from './types'

export type LogoutEvent =
  /** Emitted once there is something to log out of, before the revoke goes over the network. */
  | { type: 'starting'; serverUrl: string }
  | { type: 'revoked' }
  | { type: 'cleared' }

export type LogoutOptions = OperationOptions<LogoutEvent>

export interface LogoutResult {
  /** False when there was nothing to log out of — not an error, just nothing to do. */
  wasLoggedIn: boolean
  /** The server the revoked token belonged to, when there was one. */
  serverUrl?: string
}

export async function logout(options: LogoutOptions = {}): Promise<LogoutResult> {
  const projectRoot = options.cwd ?? process.cwd()
  const emit = emitter(options)
  const stored = loadAuth(projectRoot)

  if (!stored) {
    return { wasLoggedIn: false }
  }

  emit({ type: 'starting', serverUrl: stored.serverUrl })

  // Best effort, and deliberately not fatal: the local token is being deleted either way, and a revoke that
  // never reached the server is not a reason to leave the user still looking logged in.
  await revokeToken(stored.serverUrl, stored.deployToken)

  emit({ type: 'revoked' })

  clearAuth(projectRoot)

  emit({ type: 'cleared' })

  return { wasLoggedIn: true, serverUrl: stored.serverUrl }
}
